import { defineNuxtRouteMiddleware } from 'nuxt/app'
import { useRouterClient } from '~/composables/useRouterClient'

export default defineNuxtRouteMiddleware((to) => {
  const routerClient = useRouterClient()
  routerClient.routeChanged(to)
})
